module.exports = __webpack_public_path__ + "static/media/nexone-msp-services.eafecf42.svg";